import {Image, UnstyledButton} from "@mantine/core";
import React from "react";
import ReadMore from "@/app/(index)/read-more";
import {IArticleListForm} from "@/form/article";
import useGlobalStateStore from "@/app/(index)/use-global-state-store";

interface IProps {
    item: IArticleListForm,
}
const ArticleListSM: React.FC<IProps> = ({ item }) => {
    const { fontSize, lang } = useGlobalStateStore();

    return (
        <UnstyledButton component="a" target={item.category == "LINK" ? "_blank" : "_self"}
                        href={item.category == "LINK" ? ( lang == "tw" ? item.linkUrl!! : item.linkUrlE!! ) : `/news/detail/${item.artId}`}>
            <div
                className="flex justify-between items-center group relative py-[20px] border-b border-gray-400 border-dotted">
                <div className="flex gap-[35px] items-start">
                    {/*<div className="w-[90px]">*/}
                    {/*    <div*/}
                    {/*        style={{backgroundImage: `url(${process.env.NEXT_PUBLIC_API_HOST}/image/original/${item.coverArhId?.arhId})`}}*/}
                    {/*        className="h-[60px] w-[90px] bg-cover bg-no-repeat bg-center border border-[#abd0cb] rounded-[5px]">*/}
                    {/*    </div>*/}
                    {/*</div>*/}

                    <div className="flex flex-col">
                        <div className="text-[#b6b6b6] text-[17px] font-bold">{item.publishDate}</div>
                        <div
                            className="text-[#158a83] text-[22px] font-bold group-hover:text-black">
                            {lang == "tw" ? item.titleC : item.titleE}
                        </div>
                    </div>
                </div>
                {/*<div className="absolute top-0 right-0 group-hover:-right-[10px] transition h-full items-center flex">*/}
                {/*    <Image*/}
                {/*        h={11}*/}
                {/*        w={50}*/}
                {/*        src="/images/icon_moreArrow.png"*/}
                {/*        alt="Niar Logo"*/}
                {/*    />*/}
                {/*</div>*/}
            </div>

        </UnstyledButton>
    );
}

export default ArticleListSM;
